import { render, staticRenderFns } from "./TributePlaylistExpansion.vue?vue&type=template&id=0af9cfd4"
import script from "./TributePlaylistExpansion.vue?vue&type=script&lang=js"
export * from "./TributePlaylistExpansion.vue?vue&type=script&lang=js"
import style0 from "./TributePlaylistExpansion.vue?vue&type=style&index=0&id=0af9cfd4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports